let authErrors = {
    "Password must be atleast 5 characters": "Slaptažodis privalo būti bent 5 simbolių ilgio",
    "User not found": "Vartotojas neegzistuoja",
    "Password does not match": "Neteisingas slaptažodis",
    "User already exists": "Vartotojas jau egzistuoja"
}   

export default authErrors;